export default __webpack_public_path__ + "static/Talpool-5534607799c5d11b5d985509a0f75994.webp";